import script from "./ofertas_laborales.vue?vue&type=script&setup=true&lang=js"
export * from "./ofertas_laborales.vue?vue&type=script&setup=true&lang=js"

import "./ofertas_laborales.vue?vue&type=style&index=0&id=597f2bf6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597f2bf6"]])

export default __exports__